import { useEffect, useState } from "react";
import { Youtube, PlayCircle } from "lucide-react";
import { api, ytEmbed } from "@/lib/api";

export default function VideoGallery() {
  const [videos, setVideos] = useState([]);

  useEffect(() => {
    api.get("/videos").then((r) => setVideos(r.data)).catch(() => {});
  }, []);

  if (!videos.length) return null;

  const single = videos.length === 1;

  return (
    <section id="videos" className="bg-white py-20 lg:py-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="max-w-2xl">
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-red-600 flex items-center gap-2">
            <Youtube className="h-4 w-4" /> Watch & Learn
          </p>
          <h2 className="mt-3 font-heading text-3xl sm:text-4xl lg:text-5xl font-black tracking-tight text-slate-900">
            Garage Door Videos & Tips
          </h2>
          <p className="mt-4 text-lg text-slate-600">
            Real repairs, helpful tips, and a look at how our local team works across Prosper & Collin County.
          </p>
        </div>

        <div
          className={`mt-12 gap-6 ${single ? "flex justify-center" : "grid sm:grid-cols-2 lg:grid-cols-3"}`}
          data-testid="video-gallery"
        >
          {videos.map((v) => (
            <figure
              key={v.id}
              className={`border border-slate-200 rounded-sm overflow-hidden bg-white w-full ${
                v.vertical ? "max-w-[330px]" : single ? "max-w-2xl" : ""
              }`}
              data-testid={`public-video-${v.id}`}
            >
              <div className={`${v.vertical ? "aspect-[9/16]" : "aspect-video"} bg-slate-900`}>
                <iframe
                  src={ytEmbed(v.video_id)}
                  title={v.title}
                  className="w-full h-full"
                  loading="lazy"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                />
              </div>
              <figcaption className="p-5">
                {v.tag && <span className="text-[11px] font-bold uppercase tracking-wide text-red-600">{v.tag}</span>}
                <h3 className="mt-1 font-heading font-bold text-slate-900 flex items-start gap-2">
                  <PlayCircle className="h-4 w-4 text-red-600 mt-1 shrink-0" /> {v.title}
                </h3>
                {v.description && <p className="mt-2 text-sm text-slate-600 leading-relaxed line-clamp-3">{v.description}</p>}
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
